import { atom } from 'jotai';

export const transactionIdAtom = atom<string | undefined>(undefined);
